<template>
    <v-container fluid>
        <page-header title="Arenas" icon="mdi-stadium-outline">
            <template v-slot:actions>
                <v-btn class="white--text" depressed small color="black" @click="createArena">
                    <v-icon left small>mdi-plus</v-icon>Create
                </v-btn>
            </template>
            <table-filters :fields="filterFields" :value="filterValues" @apply="applyFilters" />
        </page-header>
        <array-view
            :items="arenas"
            :headers="displayInfo"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            :sort-by="sort.sortBy"
            :sort-desc="sort.sortDesc"
            @handleClick="handleClick"
            @paginationChange="paginationChange"
            @sortChange="changeSort"
            @onDelete="onDelete"
        />
    </v-container>
</template>

<script>
    import arenaService from '@/services/arena'
    import ArrayView from '@/components/ArrayView'
    import TableFilters from '@/components/TableFilters'
    import PageHeader from '@/components/PageHeader'
    import listTable from '@/mixins/listTable'

    export default {
        name: 'Arena',
        components: { ArrayView, TableFilters, PageHeader },
        mixins: [listTable],
        data: () => {
            return {
                successfullImport: null,
                arenas: [],
                displayInfo: [
                    {
                        text: 'Id',
                        value: 'id'
                    },
                    {
                        text: 'Name',
                        value: 'name'
                    },
                    {
                        text: 'Coordinates',
                        value: 'coordinates'
                    },
                    {
                        text: 'Address',
                        value: 'address'
                    },
                    {
                        text: 'Active',
                        value: 'active'
                    }
                ],
                tableKey: 'arenas',
                filterFields: [
                    { key: 'name', label: 'Name', type: 'text' },
                    { key: 'address', label: 'Address', type: 'text' },
                    { key: 'active', label: 'Active', type: 'boolean' }
                ],
                showImportDialog: false,
                size: 5,
                totalPages: 0,
                page: 1,
                loading: false
            }
        },
        created() {
            this.fetchItems()
        },
        methods: {
            handleClick(action, item) {
                this.$router.push(`/arenas/${item.id}/${action}`)
            },
            createArena() {
                this.$router.push(`/arenas/create`)
            },
            fetchItems() {
                this.loading = true
                arenaService.getFilteredArenas(this.filterQuery, this.page, this.size, this.sort).then(resp => {
                    this.arenas = resp.data.content
                    this.totalPages = resp.data.totalPages
                    this.loading = false
                })
            },
            onDelete(item, page) {
                arenaService.deleteArena(item.id).then(() => {
                    this.page = page
                    this.fetchItems()
                })
            }
        }
    }
</script>

<style scoped>
.card-title {
    display: flex;
}

.v-list-item {
    min-height: 30px !important;
}

.v-card {
    min-width: 250px;
    position: relative;
}

.header-card {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1%;
}

.header-buttons {
    align-self: center;
}

.edit-button:hover {
    background-color: whitesmoke;
    color: white;
}

.screen-card {
    padding: 4%;
}

.overflow-text {
    max-width: 79%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.pagination {
    justify-content: center;
}
</style>
